<template>
  <div class="yunxiao teacher organization add" data-test="base-organization-add">
    <div class="top-banner">
      <!-- <div class="line-1">轻松办学&emsp;移动管家</div>
      <div class="line-2">一部手机管理一个学校</div> -->
    </div>
    <div class="wrapper">
      <div class="title">机构名称（必填）</div>
      <div class="input-line">
        <input placeholder="请输入机构全称或简称" v-model="companyName" maxlength="30" />
      </div>
      <div class="title">联系人姓名</div>
      <div class="input-line">
        <input placeholder="请输入机构联系人姓名" v-model="contactPerson" maxlength="20" />
      </div>
    </div>

    <!-- <div>
      <van-field
        v-model="companyName"
        label="机构名称"
        placeholder="请输入"
        maxlength="30"
        input-align="right"
        required
      />
      <van-field v-model="contactPerson" label="联系人" placeholder="请输入" maxlength="20" input-align="right" />
    </div> -->
    <div class="btn-wrapper">
      <van-button square round block type="primary" @click="nextStep" > 下一步 </van-button>
      <div class="btn-like flex-center" @click="logout" v-if="$route.query.login">退出登录</div>
    </div>
    <div class="bottom">
      如果您的机构正在使用云校，请联系管理员将您添加为员工
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganizationAdd',
  data: () => ({
    pageTitle: '创建机构',
    choosedTypes: [],
    customerTypeColumns: [],
    companyName: '',
    contactPerson: '',
  }),
  mounted() {
    // if (this.$route.query.login) {
    //   this.fromLogin = true;
    // }
  },
  methods: {
    logout() {
      vant.Dialog.alert({
        message: '确认退出？',
        confirmButtonText: '退出',
        showCancelButton: true,
      })
        .then(() => {
          this.$api.teacherLogout().then(res => {
            app.ls.remove('x3-teacher-token');
            app.teacher.switchUser();
          });
        })
        .catch(err => {
          console.log('不退出了');
        });
    },
    nextStep() {
      if (!this.companyName) {
        this.$toast('请填写机构名称...');
        return false;
      }

      this.$router.push({
        name: 'organizationTypesChoose',
        query: {
          companyName: this.companyName,
          contactPerson: this.contactPerson,
          from: this.$route.query.login ? 'login' : 'add',
        },
      });
    },
  },
};
</script>

<style lang="scss">
.yunxiao.teacher.organization.add {
  overflow: auto;
  background-color: var(--white);
  .wrapper {
    background-color: var(--white);
    margin-top: calc(var(--gap) * -30);
    padding: calc(var(--gap) * 1) calc(var(--gap) * 16) calc(var(--gap) * 40);
    border-top-left-radius: calc(var(--radius-base) * 3);
    border-top-right-radius: calc(var(--radius-base) * 3);
  }
  .top-banner {
    width: 100%;
    height: 224px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/00005.png);
    padding-top: 106px;
    .line-1 {
      font-size: 24px;
      font-weight: var(--bold);
      color: var(--white);
      line-height: 36px;
      margin-left: 16px;
    }
    .line-2 {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
      margin-top: 4px;
      margin-left: 16px;
      color: var(--white);
    }
  }
  input {
    padding: 0 calc(var(--gap) * 16);
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    color: var(--black);
    box-shadow: unset;
    border: unset;
    line-height: 1;
    font-size: var(--fs-lg);
    background: var(--g1);
    outline: unset;
    border-radius: var(--radius-sm);
    &::placeholder {
      color: var(--g5);
      padding-top: 3px;
    }
  }
  .title {
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g7);
    margin-bottom: 8px;
    margin-top: 20px;
  }
  .input-line {
    margin-bottom: calc(var(--gap) * 12);
    display: flex;
    align-items: center;
    height: 46px;
    background: var(--g1);
    border-radius: var(--radius-sm);
  }
  .btn-wrapper {
    padding: 0 16px;
  }

  .btn-like {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    text-align: center;
    color: var(--g6);
    margin-top: 20px;
  }
  .bottom {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color: var(--g5);
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 40px;
    left: 0;
  }
  .van-button--primary{
    background-color: #8070F5;
    border: 1px solid #8070F5;
  }
}
</style>
